module.exports = __webpack_public_path__ + "static/media/notepadCustom.a5e5874b.png";